
export default function PricingTiers() {
  const tiers = [
    {
      name: 'Founder',
      price: '$25',
      period: '/month',
      description: 'Billed $300/year',
      features: [
        'Unlimited pleadings and contracts',
        'Voice dictation from anywhere',
        'Court-specific templates',
        'Local jurisdictions',
        'Founder badge',
        'Rate locked forever'
      ],
      cta: 'Claim Founder Spot',
      popular: true,
      spotsLeft: 247
    },
    {
      name: 'Pre-Launch',
      price: '$79',
      period: '/month',
      description: 'Cancel anytime',
      features: [
        'Unlimited pleadings and contracts',
        'Voice dictation from anywhere',
        'Court-specific templates',
        'Local jurisdictions',
        'Early access to new features'
      ],
      cta: 'Join Pre-Launch',
      popular: false
    },
    {
      name: 'Standard',
      price: '$149',
      period: '/month',
      description: 'Coming at public launch',
      features: [
        'Unlimited pleadings and contracts',
        'Voice dictation from anywhere',
        'Court-specific templates',
        'Local jurisdictions'
      ],
      cta: 'Join Waitlist',
      popular: false
    }
  ];

  return (
    <section className="py-20 sm:py-28 bg-white">
      <div className="max-w-[1200px] mx-auto px-6 sm:px-8">
        <div className="text-center mb-16">
          <h2 className="font-harvey-serif text-[#09090b] text-[32px] sm:text-[42px] lg:text-[52px] font-normal leading-tight tracking-tight mb-4">
            Choose Your Plan
          </h2>
          <p className="font-harvey-sans text-[#71717a] text-[16px] sm:text-[18px] font-light tracking-wide max-w-[600px] mx-auto">
            Start with founder pricing and keep it forever, or wait for standard launch pricing
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-[1100px] mx-auto">
          {tiers.map((tier, index) => (
            <div
              key={index}
              className={`relative rounded-2xl p-8 flex flex-col ${
                tier.popular
                  ? 'bg-[#09090b] text-white ring-2 ring-[#d4af37] shadow-2xl scale-105'
                  : 'bg-[#f5f0e8] text-[#09090b] border border-[#e8dcc8]'
              }`}
            >
              {tier.popular && (
                <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-[#d4af37] text-black px-4 py-1 rounded-full text-sm font-harvey-sans font-medium tracking-wide whitespace-nowrap">
                  Most Popular
                </div>
              )}

              {tier.spotsLeft && (
                <div className="mb-4 text-center">
                  <span className="font-harvey-sans text-[#d4af37] text-sm font-medium tracking-wide">
                    Only {tier.spotsLeft} spots remaining
                  </span>
                </div>
              )}

              <div className="text-center mb-6">
                <h3 className={`font-harvey-serif text-[28px] font-normal tracking-tight mb-2 ${tier.popular ? 'text-white' : 'text-[#09090b]'}`}>
                  {tier.name}
                </h3>
                <div className="flex items-baseline justify-center gap-1 mb-2">
                  <span className={`font-harvey-serif text-[48px] font-normal tracking-tight ${tier.popular ? 'text-white' : 'text-[#09090b]'}`}>
                    {tier.price}
                  </span>
                  <span className={`font-harvey-sans text-[18px] font-light tracking-wide ${tier.popular ? 'text-[#d4d4d8]' : 'text-[#71717a]'}`}>
                    {tier.period}
                  </span>
                </div>
                <p className={`font-harvey-sans text-[14px] font-light tracking-wide ${tier.popular ? 'text-[#d4d4d8]' : 'text-[#71717a]'}`}>
                  {tier.description}
                </p>
              </div>

              <ul className="space-y-4 mb-8 flex-grow">
                {tier.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <span className={`text-[20px] mt-0.5 ${tier.popular ? 'text-[#d4af37]' : 'text-[#8B4513]'}`}>
                      ✓
                    </span>
                    <span className={`font-harvey-sans text-[15px] font-light tracking-wide ${tier.popular ? 'text-[#d4d4d8]' : 'text-[#52525b]'}`}>
                      {feature}
                    </span>
                  </li>
                ))}
              </ul>

              <button
                className={`w-full py-4 px-6 rounded-lg font-harvey-sans text-[15px] font-medium tracking-wide transition-all whitespace-nowrap cursor-pointer ${
                  tier.popular
                    ? 'bg-[#d4af37] text-black hover:bg-[#c9a432] shadow-lg hover:shadow-xl'
                    : 'bg-[#8B4513] text-white hover:bg-[#7a3c11]'
                }`}
              >
                {tier.cta}
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
